import { InDefCommonFlagType } from "../../util/general-code/enums/general-codes";

export const TEMPLATE_FILE_URL = {
  PIC_ADDRESS: "spreadsheet-template/component-detail-page-pic-address.xlsx",
  EDH_PROTOCOL_ATTRIBUTE:
    "spreadsheet-template/component-detail-page-edh-protocol-attribute.xlsx",
};

export const REQUEST_CD_TYPES = {
  CPNT_OWN_TYPE: "cpnt_own_type",
  CPNT_ALCTN_TYPE: "cpnt_alctn_type",
  CLOD_SRVC: "clod_srvc",
  CLOD_SRVC_RGN: "clod_srvc_rgn",
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
  INTERFACE_START_METHOD_TYPE: "interface_start_method_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;
